/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Quote created from the pricing page, with the file carrying it: a quote meant for the manager of a company is created on another file than the one of the simulation.
 * 
 * @export
 * @interface CreatedQuoteDto
 */
export interface CreatedQuoteDto {
    /**
     * 
     * @type {string}
     * @memberof CreatedQuoteDto
     */
    quoteId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedQuoteDto
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedQuoteDto
     */
    funnelId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedQuoteDto
     */
    productLabel?: string | null;
    /**
     * Name of the first beneficiary of the file; null when the file has none
     * @type {string}
     * @memberof CreatedQuoteDto
     */
    beneficiaryName?: string | null;
}

/**
 * Check if a given object implements the CreatedQuoteDto interface.
 */
export function instanceOfCreatedQuoteDto(value: object): value is CreatedQuoteDto {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('funnelId' in value) || value['funnelId'] === undefined) return false;
    return true;
}

export function CreatedQuoteDtoFromJSON(json: any): CreatedQuoteDto {
    return CreatedQuoteDtoFromJSONTyped(json, false);
}

export function CreatedQuoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedQuoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteId': json['quoteId'],
        'riskId': json['riskId'],
        'funnelId': json['funnelId'],
        'productLabel': json['productLabel'] == null ? undefined : json['productLabel'],
        'beneficiaryName': json['beneficiaryName'] == null ? undefined : json['beneficiaryName'],
    };
}

export function CreatedQuoteDtoToJSON(json: any): CreatedQuoteDto {
    return CreatedQuoteDtoToJSONTyped(json, false);
}

export function CreatedQuoteDtoToJSONTyped(value?: CreatedQuoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quoteId': value['quoteId'],
        'riskId': value['riskId'],
        'funnelId': value['funnelId'],
        'productLabel': value['productLabel'],
        'beneficiaryName': value['beneficiaryName'],
    };
}

